import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { clientRoute } from '../route';

export const clientDetailRoute = createRoute({
	path: '/detail',
	getParentRoute: () => clientRoute,
	component: lazyRouteComponent(
		() => import('./ClientDetailPage'),
		'ClientDetailPage',
	),
});
